import ReactTable from 'react-table';
import React from 'react';
import PropTypes from 'prop-types';
import { columns } from './gridConfig';

// Local Deps

export default class InformationGrid extends React.PureComponent {
  static propTypes = {
    items: PropTypes.instanceOf(Array).isRequired,
  };

  render() {
    const { items } = this.props;

    const modifiedColumns = columns.map(col => {
      if (col.accessor === 'id') {
        return {
          ...col,
          Cell: row => (
            <a
              href={`https://dibbs2.bsm.dla.mil/Downloads/RFQ/${row.value.slice(-1)}/${row.value}.PDF`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {row.value}
            </a>
          ),
        };
      }
      return col;
    });

    console.log(items);
    return (
      <div className="nf-drawings__grid">
        <ReactTable
          data={items}
          columns={modifiedColumns}
          defaultPageSize={1}
          expander
          showPageSizeOptions={false}
          showPagination={false}
          style={{ textAlign: 'center' }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/InformationGrid/InformationGrid.jsx